import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SuccessDialog = ({
  open,
  title = "Thank you!",
  message = "Your message has been received. Our team will be in touch soon.",
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    aria-labelledby="success-dialog-title"
    PaperProps={{
      sx: {
        position: "relative",
        overflow: "hidden",
        borderRadius: 2,
        backgroundColor: "#fffefa",
        boxShadow: "0 28px 90px rgba(20, 19, 16, 0.28)",
      },
    }}
    BackdropProps={{
      sx: { backgroundColor: "rgba(23, 22, 19, 0.68)" },
    }}
  >
    <IconButton
      aria-label="Close success message"
      onClick={onClose}
      sx={{
        position: "absolute",
        top: 12,
        right: 12,
        color: "#716e65",
      }}
    >
      <CloseIcon />
    </IconButton>
    <DialogContent
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: { xs: 3, sm: 5 },
        py: { xs: 5, sm: 6 },
        textAlign: "center",
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          position: "relative",
          display: "grid",
          width: 104,
          height: 104,
          mb: 3,
          placeItems: "center",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(213,189,145,0.25) 0%, rgba(213,189,145,0.08) 67%, transparent 68%)",
          animation: "successPop 650ms cubic-bezier(.2,.8,.2,1) both",
          "@keyframes successPop": {
            "0%": { opacity: 0, transform: "scale(.55)" },
            "65%": { opacity: 1, transform: "scale(1.08)" },
            "100%": { opacity: 1, transform: "scale(1)" },
          },
          "& svg": {
            width: 76,
            height: 76,
            overflow: "visible",
          },
          "& .success-ring": {
            fill: "#fffefa",
            stroke: "#9a794b",
            strokeWidth: 2,
            strokeDasharray: 190,
            strokeDashoffset: 190,
            animation: "drawRing 550ms ease-out 120ms forwards",
          },
          "& .success-check": {
            fill: "none",
            stroke: "#75603b",
            strokeWidth: 3.5,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: 34,
            strokeDashoffset: 34,
            animation: "drawCheck 350ms ease-out 550ms forwards",
          },
          "@keyframes drawRing": {
            to: { strokeDashoffset: 0 },
          },
          "@keyframes drawCheck": {
            to: { strokeDashoffset: 0 },
          },
          "@media (prefers-reduced-motion: reduce)": {
            animation: "none",
            "& .success-ring": {
              strokeDashoffset: 0,
              animation: "none",
            },
            "& .success-check": {
              strokeDashoffset: 0,
              animation: "none",
            },
          },
        }}
      >
        <svg viewBox="0 0 72 72" role="presentation">
          <circle className="success-ring" cx="36" cy="36" r="30" />
          <path className="success-check" d="m22 37 9 9 19-21" />
        </svg>
      </Box>
      <Typography
        sx={{
          mb: 1,
          color: "#9a794b",
          fontSize: "0.67rem",
          fontWeight: 700,
          letterSpacing: "0.2em",
          textTransform: "uppercase",
        }}
      >
        HOMELY BUILDOFIY
      </Typography>
      <Typography
        id="success-dialog-title"
        component="h2"
        sx={{
          color: "#292720",
          fontFamily: 'Georgia, "Times New Roman", serif',
          fontSize: { xs: "2rem", sm: "2.25rem" },
          fontWeight: 400,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          maxWidth: 360,
          mt: 1.5,
          color: "#716e65",
          fontSize: "0.95rem",
          lineHeight: 1.75,
        }}
      >
        {message}
      </Typography>
      <Button
        onClick={onClose}
        variant="contained"
        sx={{
          mt: 3.5,
          minWidth: 150,
          px: 3,
          py: 1.2,
          borderRadius: 0,
          backgroundColor: "#292720",
          color: "#fff",
          fontSize: "0.7rem",
          fontWeight: 700,
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          "&:hover": { backgroundColor: "#49463d" },
        }}
      >
        Done
      </Button>
    </DialogContent>
  </Dialog>
);

export default SuccessDialog;
